<div class="modal-content">
  <div id="view-report">
    <div *ngIf="purchaseReport" name="reportForm" novalidate="">
      <div class="modal-header">
        <h1 class="modal-title">
          <span *ngIf="purchaseReport.reportType === ReportType.PAQ">Aquarium </span>
          Dealer Purchase Receipt Report for {{purchaseReport.reportDate.toDate() | date:'longDate'}}
        </h1>
      </div>
      <div class="modal-body">
        <div>
          <div class="row">
            <div class="col-md-6">
              <div class="card sellerCard" *ngIf="purchaseReport.seller">
                <div class="card-body">
                  <dl class="row mb-0">
                    <dt class="col-sm-6">Fisher Name</dt>
                    <dd class="col-sm-6">{{purchaseReport.seller.name || '--'}}</dd>
                    <dt class="col-sm-6">Comm. Marine Lic. #</dt>
                    <dd class="col-sm-6">{{purchaseReport.seller.licenseNumber || '--'}}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card sellerCard" *ngIf="totalReportAmount">
                <div class="card-body">
                  <span class="sellerCardHeader">Report Total:</span> <br>
                  <span class="sellerCardValue">{{totalReportAmount | bigCurrency}}</span> </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div *ngIf="purchaseReport.purchases?.length; else emptyTable" class="col-md-12 responsive-table-cell">
              <h2>Purchases</h2>
              <table class="table table-bordered table-responsive-sm">
                <thead class="thead-dark">
                  <tr>
                    <th>Species</th>
                    <th *ngIf="isLbsBased()">Lbs. Bought</th>
                    <th>Pcs. Bought</th>
                    <th *ngIf="isLbsBased()">Price per Lb.</th>
                    <th *ngIf="isPcsBased()">Price per Pc.</th>
                    <th *ngIf="isConditionNeeded()">Condition</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let purchase of purchaseReport.purchases">
                    <td>{{purchase.speciesDisplayName}}</td>
                    <td *ngIf="isLbsBased()">{{purchase.lbsBought}}</td>
                    <td *ngIf="purchase.piecesBought && 0 < purchase.piecesBought; else emptyTD">{{purchase.piecesBought}}</td>
                    <td *ngIf="isLbsBased()">{{purchase.pricePerLb | bigCurrency}}</td>
                    <td *ngIf="isPcsBased()">{{purchase.pricePerPc | bigCurrency}}</td>
                    <td *ngIf="isConditionNeeded()"><span *ngIf="purchase.condition">{{purchase.condition?.description}} ({{purchase.condition?.code}})</span></td>
                    <td>{{purchase.value | bigCurrency}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h2>Amendments</h2>
              <table *ngIf="purchaseReport.amendments?.length; else emptyTable" class="table table-bordered table-responsive-sm">
                <thead class="thead-dark">
                  <tr>
                    <th class="align-top">Amendment Name</th>
                    <th class="align-top">Amendment Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let amendment of purchaseReport.amendments">
                    <td class="word-wrap">{{amendment.name}}</td>
                    <td>{{amendment.amount | bigCurrency}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <ng-template #emptyTable>
            --
          </ng-template>
          <div class="row">
            <div class="col-md-6">
              <h2>Vessel Info</h2>
              <dl class="row mb-0">
                <dt class="col-sm-4">Name</dt>
                <dd class="col-sm-8 word-wrap">{{purchaseReport.vessel.name || '--'}}</dd>
                <dt class="col-sm-4">ID</dt>
                <dd class="col-sm-8">{{purchaseReport.vessel.id || '--'}}</dd>
              </dl>
            </div>
            <div class="col-md-6 remarks">
              <h2>Remarks</h2>
              {{purchaseReport.remarks || '--'}}
            </div>
          </div>
          <hr>
          <div class="btn-group btn-group-vertical customRadio" data-toggle="buttons">

            <label class="btn active disabled">
              <input [checked]="purchaseReport.notifyFisher" type="checkbox" name="sendEmail" id="sendEmail" disabled="disabled">
              <i class="far fa-square"></i><i class="far fa-check-square"></i>
              <span> Send email receipt to fisher</span>
            </label>
          </div>
          <ng-container *appHasAnyAuthority="['DEALER_INFO']">
            <ng-container *ngIf="!isHistoricalView">
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <h2>History</h2>
                </div>
                <div class="col-md-12">
                  <div *ngFor="let history of purchaseReport.history">
                    {{history.actionDate | date:'longDate'}}: <a href="#" (click)="onHistoryClick(history.id); false">{{history.action}}</a> by {{history.actionRequesterName}}
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div *ngIf="showDeleteWarning" class="alert alert-danger">
          <span>Are you sure you want to delete this report? To confirm, click delete again.</span>
        </div>
      </div>
      <div class="modal-footer">
        <div class="reportDate float-left">
          <strong *ngIf="purchaseReport.reportDate">Report Date: {{purchaseReport.reportDate.toDate() |
            date:'longDate'}}</strong>
          <br>
          <strong *ngIf="purchaseReport.receivedDate">Received Date: {{purchaseReport.receivedDate.toDate() |
            date:'longDate'}}</strong>
        </div>
        <div>
          <ng-container *ngIf="!isHistoricalView; else close_historical_view">
            <ng-container *ngIf="purchaseReport.modifiable">
              <button *appHasAnyAuthority="['MANAGE_REPORT', 'MANAGE_MY_REPORT']" type="button" class="btn-xs-block btn btn-danger mr-1"
                      (click)="onDeleteClick()">
                <i class="fas fa-trash-alt"></i> Delete
              </button>
              <button *appHasAnyAuthority="['MANAGE_REPORT', 'MANAGE_MY_REPORT']" type="button" class="btn-xs-block btn btn-primary mr-1"
                      (click)="onEditClick()" >
                <i class="fas fa-pencil-alt"></i> Edit
              </button>
            </ng-container>
            <button (click)="onPrintClick()" class="btn-xs-block btn btn-secondary mr-1" type="button">
              <i class="fas fa-print"></i> Print
            </button>
            <button (click)="onCancelClick()" class="btn-xs-block btn btn-secondary" type="button">
              <i class="fas fa-times"></i> Return to Reports
            </button>
          </ng-container>
          <ng-template #close_historical_view>
            <ng-container *appHasAnyAuthority="['DEALER_INFO']">
              <button (click)="onCancelClick()" class="btn-xs-block btn btn-secondary" type="button">
                <i class="fas fa-times"></i> Close
              </button>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyTD>
  <td>&nbsp;</td>
</ng-template>

